import React from 'react';

import AssetManager from '@components/workbench/individual/asset_manager/main';
import Controls from '@components/workbench/individual/resize/controls';

class Resize extends React.Component {
  render() {
    return (
      <AssetManager>
        <Controls />
      </AssetManager>
    );
  }
}

export default Resize;
